import { render, staticRenderFns } from "./popRevoke.vue?vue&type=template&id=65595153&scoped=true"
import script from "./popRevoke.vue?vue&type=script&lang=js"
export * from "./popRevoke.vue?vue&type=script&lang=js"
import style0 from "./popRevoke.vue?vue&type=style&index=0&id=65595153&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65595153",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/Test-OA/jh-oa-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('65595153')) {
      api.createRecord('65595153', component.options)
    } else {
      api.reload('65595153', component.options)
    }
    module.hot.accept("./popRevoke.vue?vue&type=template&id=65595153&scoped=true", function () {
      api.rerender('65595153', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/assetManagement/common/popRevoke.vue"
export default component.exports